<template>
  <header>
    <meta name="viewport"
          content="width=device-width,initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
  </header>
  <div class="app">
    <router-view></router-view>
  </div>
</template>

<style>
html, body {
  margin: 0;
  padding: 0;
  border: 0;
  scrollbar-width: none; /* 隐藏滚动条 (Firefox) */
  -ms-overflow-style: none; /* 隐藏滚动条 (IE 10+) */
}

.app {
  width: 100%;
  height: auto;
  font-family: 'Alibaba Sans', sans-serif !important;
}

/* #saasbox_page_content p {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
} */

@media (max-width: 768px) {
}

</style>
<script>
import Index from "@/views/index/Index.vue";
import {mapActions, mapState} from "vuex";
import Order from "@/views/order/Order.vue";
import LogOut from "@/views/logout/LogOut.vue";

export default {
  name: "App",
  components: {LogOut, Order, Index},
  data() {
    return {
      currentPage: 'order', // 默认显示的页面
    }
  },
  created() {
    this.updateLanguage();
    this.updatePage(); // 初始化时根据当前URL显示正确的组件
    window.addEventListener('popstate', this.updatePage); // 监听浏览器前进/后退事件
    window.addEventListener('hashchange', this.updatePage); // 监听 hash 变化事件（如果你用 hash 模式）
    // this.bindInvitationCode();
  },
  computed: {
    ...mapState(['indexFlag'])
  },

  beforeDestroy() {
    window.removeEventListener('popstate', this.updatePage);
    window.removeEventListener('hashchange', this.updatePage);
  },
  methods: {
    ...mapActions(['updateTokenStore', 'updateUserInfoStore']),
    // logout() {
    //   this.$axios.get("https://familypro.io/user/logout").then(res => {
    //     if (res.code === 304 || res.code === 200) {
    //       localStorage.removeItem("userinfo");
    //       localStorage.removeItem("token");
    //     }
    //   })
    //   // 在这里处理实际的登出逻辑，例如清除用户状态，重定向等
    // },
    updatePage() {
      const path = window.location.pathname; // 获取当前路径
      if (path === '/order') {
        this.currentPage = 'order';
      } else if (path === '/logout') {
        this.currentPage = 'logout';
      } else {
        this.currentPage = 'index'; // 默认页面
      }
    },
    navigateTo(path) {
      history.pushState({}, '', path); // 手动修改 URL
      this.updatePage(); // 触发页面更新
    },
    updateLanguage() {
      try {
        let path_lang = window.location.href.split('/')[3]
        if (["br", "cn", "de", "en", "es", "fr", "it", "jp", "ko", "ru",].includes(path_lang)) {
          language = path_lang
          this.$i18n.locale = language;
          return;
        }
        let language = this.$cookies.get("sbox-l")
        if (!language || language === undefined) {
          this.$i18n.locale = 'en';
          return;
        }
        this.$i18n.locale = language;
      } catch (e) {
        this.$i18n.locale = 'en';
      }
    },
    async bindInvitationCode() {
      // 使用 URLSearchParams 获取参数
      // console.log("获取邀请码")
      let inviteCode = localStorage.getItem('inviteCode')
      if (inviteCode == null) {
        const urlParams = new URLSearchParams(window.location.search);
        inviteCode = urlParams.get('invite');
        if (inviteCode == null) {
          // console.log("无邀请码不需要操作")
          return
        }
        localStorage.setItem("inviteCode", inviteCode)
      }
      console.log("inviteCode: ", inviteCode);
      const model = await import('./utils/FPUser');
      const userInfo = await model.getUserInfo();
      if (userInfo == null) {
        // 未登录
        console.log("未登录")
        return;
      }
      const FPUtils = await import('./utils/FPUser');
      let tokenJson = await FPUtils.login(userInfo, inviteCode);
      // this.updateUserInfoStore(userInfo);
      this.updateTokenStore(tokenJson);
      window.Countly.q.push(['add_ltc_event', {
        'objectName': 'invite_code_url',
        'eventName': 'visit',
        'eventLocation':inviteCode,
        'properties': {
            "invite_code": inviteCode,
            "userInfo": userInfo,
            "url": window.location.href,
            "source_url": document.referrer
        }
      }]);
      localStorage.removeItem("inviteCode");
    }
  },
}
</script>